import { Alert } from '@warp-ds/react';
import { useObject } from '@/hooks/useObject';

export const PausedAdAlert = () => {
    const objectData = useObject();

    return (
        <Alert type="warning" show={!!objectData.status?.isPaused && !!objectData.user?.isOwner}>
            <strong>Inaktiv annonse</strong>
            <p className="mt-8">
                Denne annonsen er midlertidig satt på pause og vises ikke i søkeresultater. Den er kun synlig for deg og eventuelle barn kan
                se den. Avventende eller ny fremtidige bestillinger.
            </p>
        </Alert>
    );
};
